module.exports = __webpack_public_path__ + "media/08.dd8d4068.mp4";